import { TAppState } from '../../types/appState';

export function deleteMessageSelector(state: TAppState) {
  return state.deleteMessage;
}
